"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = number;

function number(x) {
  return +x;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-scale/src/number.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-scale/src/number.js
// module chunks = 1